// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__AM8Nq","isActive":"Avatar_isActive__7fCWb","initials":"Avatar_initials__JqJK9","link":"Avatar_link__LrqoC"};